import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import axios from 'axios';
import _ from 'lodash';
import { helperGetApiHeaders, helperConvertApiRoute, axiosErrorHandler } from 'helpers/ApiHelper';
import { fetchNextPanelPage } from 'components/Panel/PanelActions';
import { StickyContainer } from 'react-sticky';
import altHeaderTheme from 'screens/Shows/AltHeader.css';

export const FETCH_NEXT_PAGE = 'FETCH_NEXT_PAGE';
export const TOGGLE_FETCHING = 'TOGGLE_FETCHING';
export const RESET_PAGINATION = 'RESET_PAGINATION';
export const INITIAL_STATE = {
  panels: null,
  errors: null,
  filteredPanel: null,
  nextPage: null,
  paginationItems: [],
  hasMoreItems: true,
  fetching: false,
  tabs: null,
  currentTab: null,
  filters: null,
  stickyHeader: null,
};

export function toggleFetching(value) {
  return {
    type: TOGGLE_FETCHING,
    payload: { value },
  };
}

export function resetPagination() {
  return {
    type: RESET_PAGINATION,
  };
}

export function setFetching(action, state) {
  const value = _.get(action, 'payload.value', null);
  const { fetching } = state;
  return {
    ...state,
    fetching: value || !fetching,
  };
}

export function setResetPagination({ state }) {
  return {
    ...state,
    ...INITIAL_STATE,
  };
}

export function setNextPage(action, state) {
  const nextPage = _.get(action, 'payload.data.view.next', false);
  const newPage = _.get(action, 'payload.data.member', false);

  if (!newPage) return state;
  const { paginationItems: oldPaginationItems } = state;
  const newPaginationItems = oldPaginationItems || [];

  newPaginationItems.push(newPage);
  return {
    ...state,
    nextPage,
    hasMoreItems: !!nextPage,
    paginationItems: newPaginationItems,
    fetching: false,
  };
}

export function paginationLoader() {
  const { panels, filteredPanel, nextPage, hasMoreItems, accessToken, fetching } = this.props;
  if (!fetching) {
    if (hasMoreItems && nextPage) {
      this.props.toggleFetching(true);
      this.props.fetchNextPage(accessToken, nextPage, 'movies');
    } else if (!nextPage && (panels || filteredPanel)) {
      let url;
      if (panels && !filteredPanel) url = _.get(panels, 'member[0].items.view.next', null);
      if (filteredPanel) url = _.get(filteredPanel, 'view.next', null);
      if (url) {
        this.props.toggleFetching(true);
        this.props.fetchNextPage(accessToken, url, 'movies');
      }
    }
  }
}

export function fetchNextPage(accessToken, url, pageType, deviceId) {
  if (url && pageType) {
    const headers = helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId });
    const request = axios.get(helperConvertApiRoute(url), headers).catch(axiosErrorHandler);

    return {
      type: FETCH_NEXT_PAGE,
      payload: request,
    };
  }
  return {};
}

export function getPaginationNextUrl(response) {
  let data = _.get(response, 'payload.data', null);
  if (!data) data = response;
  const view =
    _.get(data, 'view', null) ||
    _.get(data, 'panels.member[0].items.view', null) ||
    _.get(data, 'items.view', null);
  return _.get(view, 'next', null);
}

export function fetchPanelPaginationLoop({ store, url, panelId, headers }) {
  if (!url) return null;
  return store.dispatch(fetchNextPanelPage(url, headers, panelId)).then(response => {
    const newUrl = getPaginationNextUrl(response);
    if (url === newUrl) return null;
    return fetchPanelPaginationLoop({ store, url: newUrl, panelId, headers });
  });
}

export function getPaginationData(items) {
  const { paginationItems } = this.props;
  let returnItems = items;
  if (paginationItems && paginationItems.length) {
    _.forEach(paginationItems, value => {
      returnItems = _.concat(returnItems, value);
    });
  }
  return returnItems;
}

export function fetchReducer({ action, state }) {
  const tabId = _.get(action, 'payload.tabId');
  const data = _.get(action, 'payload.data');
  if (!data) return state;
  const { panels } = data;
  const filteredPanel = panels && data ? null : data;
  const tabs = !filteredPanel ? panels.member : state.tabs;
  const { suggestedFilter, suggestedNetwork } = state;

  let tab = null;

  if (suggestedNetwork) {
    tab = _.find(tabs, networkTab => {
      const headline = _.toLower(networkTab.headline);
      return headline === suggestedNetwork;
    });
  }

  if (suggestedFilter && !filteredPanel) {
    // for the movies page, find the tab by the collectionType.
    tab = _.find(tabs, categoryFilter => {
      const filterName = _.toLower(categoryFilter.name);
      return filterName === suggestedFilter;
    });
  }

  let currentTab = tab ? tab.id : null;
  currentTab = tabId || currentTab || state.currentTab || _.get(tabs, '0.id', null);

  const filters = currentTab
    ? _.get(tabs.filter(lclTab => _.get(lclTab, 'id', false) === currentTab), '0.customViews')
    : state.filters;

  return {
    ...setResetPagination({ action, state }),
    panels,
    filteredPanel,
    tabs,
    currentTab,
    filters,
    paginationItems: [],
  };
}

export function renderHelper({ style, isNavScheduleRendered, renderLoader, renderFilteredPanel }) {
  const altHeaderContentClass = isNavScheduleRendered
    ? altHeaderTheme.altHeaderContentWithNav
    : altHeaderTheme.altHeaderContent;

  return (
    <StickyContainer>
      <div className={classNames(style.screen, altHeaderContentClass)}>
        {renderLoader()}
        {renderFilteredPanel()}
      </div>
    </StickyContainer>
  );
}

renderHelper.defaultProps = {
  isNavScheduleRendered: false,
  style: null,
  parentState: {},
  parentProps: {},
  renderLoader: () => {},
  renderFilteredPanel: () => {},
};

renderHelper.propTypes = {
  isNavScheduleRendered: PropTypes.bool,
  style: PropTypes.string,
  parentState: PropTypes.shape({}),
  parentProps: PropTypes.shape({}),
  renderLoader: PropTypes.func,
  renderFilteredPanel: PropTypes.func,
};
